import { render, staticRenderFns } from "./DebuggerOrderAlert.vue?vue&type=template&id=0fdda84c&scoped=true&"
import script from "./DebuggerOrderAlert.vue?vue&type=script&lang=js&"
export * from "./DebuggerOrderAlert.vue?vue&type=script&lang=js&"
import style0 from "./DebuggerOrderAlert.vue?vue&type=style&index=0&id=0fdda84c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdda84c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
